import {
  SET_USER_INFO,
  SET_ERRORS,
  SET_LOADING,
  GET_COMPLIANCE_DOC,
  NEXT_STEP,
  ADD_DOC,
  SET_NOTIFICATIONS,
  GET_UPLOADED_DOCUMENT,
  //GET_DOCUMENT_ITEM,
  GET_COMPLIANCE_DOCUMENTS,
  UPLOAD_DOCUMENT,
  //REMOVE_DOCUMENT,
  ADD_NO_SUBMITTED_DOCUMENTS,
  DONE_PROCESS,
  CLEAR_USER_INFO,
  GET_CUST_ID,
  SET_OTP_SUCCESS,
  ADD_NO_DELETED_DOCUMENTS,
  SET_TOKEN,
  GET_APPLICATION_DETAILS,
  GET_VIDEO_CALL_SCHEDULE,
  SET_VIDEO_CALL_SCHEDULE,
  SET_DISPLAY_VIDEO_CALL_SCHEDULE,
  SET_ATM_CARD_NUMBER,
  SET_ATM_CARD_BIRTHDAY,
  SUBMIT_NOMINATED_PIN,
  ATM_CARD_VALIDATION,
  ATM_CARD_ACTIVATION_SUBMIT,
  OLD_PIN_VALIDATION,
  SET_NOMINATED_PIN,
  SET_OLD_PIN,
  CARD_SESSION_VALIDATION,
  CHANGE_ATM_PIN,
  SET_LOCAL_IP,
  ACTIVATION_CODE_VALIDATION,
  SET_REF_CODE
} from './types';

export default (state, action) => {
    switch (action.type) {
    case SET_OLD_PIN:
      return {
        ...state,
        setOldPin: action.payload,
        loading: false,
      };
    case CHANGE_ATM_PIN:
      return {
        ...state,
        changePinSubmit: action.payload,
        loading: false,
      };
    case CARD_SESSION_VALIDATION:
      return {
        ...state,
        cardSessionValidation: action.payload,
        loading: false,
      };
    case SET_NOMINATED_PIN:
      return {
        ...state,
        setNominatedPin: action.payload,
        loading: false,
      };
    case ATM_CARD_ACTIVATION_SUBMIT:
      return {
        ...state,
        atmCardActivationSubmit: action.payload,
        loading: false,
      };
    case ATM_CARD_VALIDATION:
      return {
        ...state,
        atmCardValidation: action.payload,
        loading: false,
      };
      
    case ACTIVATION_CODE_VALIDATION:
      return {
        ...state,
        activationCodeValidation: action.payload,
        loading: false,
      };
      case OLD_PIN_VALIDATION:
        return {
          ...state,
          oldPinValidation: action.payload,
          loading: false,
        };
    case SUBMIT_NOMINATED_PIN:
      return {
        ...state,
        loading: false,
      };
      
    case SET_ATM_CARD_BIRTHDAY:
      return {
        ...state,
        atmCardDetailsBirthday: action.payload,
        loading: false,
      };
    case SET_ATM_CARD_NUMBER:
      return {
        ...state,
        atmCardNumberDetails: action.payload,
        loading: false,
      };
    case SET_DISPLAY_VIDEO_CALL_SCHEDULE:
      return {
        ...state,
        selectedDisplayVideoCallSchedule: action.payload,
        loading: false,
      };
    case SET_VIDEO_CALL_SCHEDULE:
      return {
        ...state,
        selectedVideoCallSchedule: action.payload,
        loading: false,
      };
    case GET_VIDEO_CALL_SCHEDULE:
      return {
        ...state,
        videoCallSchedule: action.payload,
        loading: false,
      };
    case GET_APPLICATION_DETAILS:
      return {
        ...state,
        applicationDetails: action.payload,
        loading: false,
      };
    case SET_USER_INFO:
      return {
        ...state,
        userInfo: action.payload,
        loading: false,
      };
    case SET_OTP_SUCCESS:
      return {
        ...state,
        otp_succ: action.payload,
        loading: false,
      };

    case GET_CUST_ID:
      return {
        ...state,
        customerId: action.payload,
        loading: false,
      };
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
        loading: false,
      };
    case SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };
    case ADD_NO_DELETED_DOCUMENTS:
      return {
        ...state,
        delDocs: action.payload,
        //loading: false,
      };
    case GET_COMPLIANCE_DOC:
      return {
        ...state,
        requirements: action.payload,
        loading: false,
      };
    case NEXT_STEP:
      return {
        ...state,
        step: action.payload + 1,
        loading: false,
      };
    case ADD_DOC:
      return {
        ...state,
        documents: [action.payload, ...state.documents],
        loading: false,
      };
    case GET_UPLOADED_DOCUMENT:
      return {
        ...state,
        uploadedDocuments: action.payload,
        loading: false,
      };
    // case GET_DOCUMENT_ITEM:
    //   return {
    //     ...state,
    //     documentItem: action.payload,
    //   };
    case GET_COMPLIANCE_DOCUMENTS:
      return {
        ...state,
        complianceDocuments: action.payload,
        noOfRequiredDocs: action.payload.documents.length,
        loading: false,
      };
    // case UPLOAD_DOCUMENT:
    //   // var index = state.uploadedDocuments.findIndex(
    //   //   (obj) => obj.documentId === action.payload.documentId
    //   // );
    //   // if (index !== -1) {
    //   //   var newUploadedDocuments = state.uploadedDocuments.map((doc) =>
    //   //     doc.documentType === action.payload.documentType
    //   //       ? action.payload
    //   //       : doc
    //   //   );
    //   //   return {
    //   //     ...state,
    //   //     uploadedDocuments: newUploadedDocuments,
    //   //     loading: false,
    //   //   };
    //   // } else {
    //   //('else');
    //   console.log(action.payload);
    //   console.log(state.uploadedDocuments);
    //   return {
    //     ...state,
    //     uploadedDocuments: [action.payload, ...state.uploadedDocuments],
    //     noOfUploadedDocs: state.noOfUploadedDocs + 1,
    //     loading: false,
    //   };

    case UPLOAD_DOCUMENT:
      var index = state.uploadedDocuments.findIndex(
        (obj) =>
          obj.documentId === action.payload.documentId &&
          obj.documentType === action.payload.documentType &&
          obj.orderNumber === action.payload.orderNumber
      );

      if (index !== -1) {
        var newUploadedDocuments = state.uploadedDocuments.map((doc) =>
          doc.documentType === action.payload.documentType &&
            doc.orderNumber === action.payload.orderNumber
            ? action.payload
            : doc
        );

        return {
          ...state,
          uploadedDocuments: newUploadedDocuments,
          loading: false,
        };
      } else {
        return {
          ...state,
          uploadedDocuments: [action.payload, ...state.uploadedDocuments],
          noOfUploadedDocs: state.noOfUploadedDocs + 1,
          loading: false,
        };
      }

    // case REMOVE_DOCUMENT:
    //   var newUploadedDocuments = state.uploadedDocuments;
    //   var index = state.uploadedDocuments.findIndex(
    //     (obj) => obj.documentId === action.payload.documentId
    //   );
    ////(newUploadedDocuments.splice(index, 1));

    case ADD_NO_SUBMITTED_DOCUMENTS:
      return {
        ...state,
        noOfSubmittedDocs: action.payload,
        loading: false,
      };

    case DONE_PROCESS:
      return {
        ...state,
        doneProcess: action.payload,
        loading: false,
      };

    case CLEAR_USER_INFO:
      return {
        ...state,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
      case SET_LOCAL_IP:
      return {
        ...state,
        localIP: action.payload,
      };
      case SET_REF_CODE:
      return {
        ...state,
        referenceCode: action.payload,
      };
    default:
      return state;
  }
};
